import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Page Loader Component
 */
@Component({
  selector: 'ui-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['page-loader.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageLoaderComponent {}
